import { api } from '@/api/client'
import type { components } from '@/api/types.gen'

export type ScanResult = components['schemas']['ScanResult']
export type VendorLabel = components['schemas']['VendorLabel']

/** Ask the backend what a scanned code refers to. */
export async function resolveCode(code: string): Promise<ScanResult> {
  const { data } = await api.GET('/api/scan/resolve', { params: { query: { code } } })
  return data as ScanResult
}
